export default "__VITE_ASSET__85a26743__"